// playerView 组件通用 API
import jsBridge from "../../common/jsBridge";

/**
 *
 * @param campaign 必填项, 初始化当前 player 所需要的 campaign 对象
 * @param unitId 必填项, 当前广告位 id
 * @param mute 选填, 如果没有传入, SDK 默认会跟随之前 sdkSetting 和开发者设置的全局静音配置,
 *                  如果传 1 为静音, 2 为非静音, 其他值无效
 * @param show_time 选填, 是否展示原生的 "倒计时" 控件, 默认 0 不展示
 * @param show_mute 选填, 是否展示原生的 "静音" 控件, 默认 0 不展示
 * @param show_close 选填, 是否展示原生的 "关闭按钮" 控件, 默认 0 不展示
 * @returns {Promise<any>}
 */
export function createPlayerView({unitId, campaign, mute, show_time = 0, show_mute = 0, show_close = 0}) {
    let params = {
        unitId,
        data: {
            unitId,
            campaign,
            mute,
            show_time,
            show_mute,
            show_close,
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/createPlayerView', params})
}

export function playerPlay({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerPlay', params})
}

export function playerPause({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerPause', params})
}

export function playerResume({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerResume', params})
}

export function playerStop({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerStop', params})
}

export function playerUpdateFrame({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerUpdateFrame', params})
}

export function playerMute({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerMute', params})
}

export function playerUnmute({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerUnmute', params})
}

export function playerGetMuteState({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerGetMuteState', params})
}
window.playerMute = playerMute
window.playerUnmute = playerUnmute
window.playerGetMuteState = playerGetMuteState

export function playerSetSource({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerSetSource', params})
}

export function playerSetRenderType({unitId, id, type}) {
    let params = {
        unitId,
        id,
        data: {
            type // Android不支持VideoPlayer 设置ScaleType
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/playerSetRenderType', params})
}